// Modules
import { memo, useCallback } from 'react'
import { PiEyeLight } from 'react-icons/pi'
import { PiEyeSlash } from 'react-icons/pi'

// UI
import { IconButton, InputRightElement } from '@chakra-ui/react'

const PasswordEyeIconBtn = (props) => {
  const { showPassword, setShowPassword } = props

  const handleClickShowPassword = useCallback(() => setShowPassword((show) => !show), [])

  const handleMouseDownPassword = useCallback((event) => {
    event.preventDefault()
  }, [])

  const handleMouseUpPassword = useCallback((event) => {
    event.preventDefault()
  }, [])

  return (
    <InputRightElement>
      <IconButton
        aria-label="show/hide password"
        icon={showPassword ? <PiEyeSlash /> : <PiEyeLight />}
        background="transparent"
        size="md"
        isRound
        onClick={handleClickShowPassword}
        onMouseDown={handleMouseDownPassword}
        onMouseUp={handleMouseUpPassword}
        _hover={{
          background: 'transparent',
        }}
      />
    </InputRightElement>
  )
}

export default memo(PasswordEyeIconBtn)
